<template>
  <el-card>
    <div slot="header">
      <div class="page-hedaer">
        <h4 class="page-title">提现与收益</h4>
        <span class="title-info">(每月22日结算订单佣金到可提现金额中)</span>
      </div>
    </div>

    <!-- 余额信息 -->
    <el-row :gutter="20" class="balance-row">
      <el-col :span="8">
        <el-card shadow="hover" class="balance-card">
          <div class="balance-label">可提现金额</div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              padding-left: 66px;
            "
          >
            <div class="balance-value" style="color: #f56c6c;">
              ¥{{ fenToYuan(me.withdrawable_balance) }}
            </div>
            <el-button
              type="primary"
              size="small"
              @click="showWithdrawDialog = true"
              :disabled="me.withdrawable_balance <= 0"
              style="margin-left: 20px"
            >
              提现
            </el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="balance-card">
          <div class="balance-label">已提现金额</div>
          <div class="balance-value" style="color: #67c23a;">
            ¥{{ fenToYuan(me.withdrawn_balance) }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="balance-card">
          <div class="balance-label">累计收益</div>
          <div class="balance-value" style="color: #409eff;">
            ¥{{ fenToYuan(me.withdrawable_balance + me.withdrawn_balance) }}
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 筛选栏 -->
    <el-form :inline="true" class="filter-form">
      <el-form-item label="类型">
        <el-select
          size="small"
          v-model="filters.record_type"
          placeholder="请选择类型"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="结算" value="settle"></el-option>
          <el-option label="提现" value="withdraw"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          size="small"
          v-model="filters.status"
          placeholder="请选择状态"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="审核中" value="pending"></el-option>
          <el-option label="已打款" value="completed"></el-option>
          <el-option label="提现失败" value="failed"></el-option>
          <el-option label="已退还" value="payback"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="fetchRecords(1)"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 记录表格 -->
    <el-table
      :data="records"
      v-loading="loading"
      style="width: 100%; margin-top: 20px"
    >
      <div slot="empty">
        <el-empty description="暂无数据"></el-empty>
      </div>
      <el-table-column prop="created_at" label="时间"></el-table-column>
      <el-table-column prop="record_type" label="类型">
        <template slot-scope="scope">
          {{ scope.row.record_type === "settle" ? "结算" : "提现" }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.record_type === 'withdraw'"
            :type="getStatusType(scope.row.status)"
          >
            {{ getStatusText(scope.row.status) }}
          </el-tag>
          <el-tag v-else type="success"> 已结算 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="支出/收入">
        <template slot-scope="scope">
          <span
            :class="
              scope.row.record_type === 'settle' ||
              scope.row.status === 'payback'
                ? 'income'
                : 'expense'
            "
          >
            {{
              scope.row.record_type === "settle" ||
              scope.row.status === "payback"
                ? "+"
                : "-"
            }}¥{{ fenToYuan(scope.row.amount) }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="balance_before" label="变动前" width="120">
        <template slot-scope="scope"
          >¥{{ fenToYuan(scope.row.balance_before) }}</template
        >
      </el-table-column> -->
      <el-table-column prop="balance_after" label="余额">
        <template slot-scope="scope"
          >¥{{ fenToYuan(scope.row.balance_after) }}</template
        >
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
    </el-table>

    <div class="pager" v-if="total > 0">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        @current-change="fetchRecords"
      />
    </div>

    <!-- 提现对话框 -->
    <el-dialog title="提现" :visible.sync="showWithdrawDialog" width="500px">
      <el-form :model="withdrawForm" label-width="120px">
        <el-form-item label="可提现金额">
          ¥{{ fenToYuan(me.withdrawable_balance) }}
        </el-form-item>
        <el-form-item label="提现金额">
          <el-input
            v-model.number="withdrawForm.amount"
            type="number"
            placeholder="请输入提现金额"
          >
            <template slot="prepend">¥</template>
          </el-input>
          <div class="withdraw-tip">
            单笔提现最低100元，且金额需为100元的整倍数
          </div>
        </el-form-item>
        <el-form-item label="支付宝账户">
          <div v-if="me.alipay_account">
            {{ me.alipay_name }} ({{ me.alipay_account }})
          </div>
          <div v-else style="color: #f56c6c">未设置</div>
        </el-form-item>
        <el-form-item label="提现剩余次数">
          <div>{{me.last_withdraw_month==currentYearMonth?0:1}}次</div>
          <div class="withdraw-tip">
            由于支付宝风控，每月只能提现1次，谢谢理解
          </div>
        </el-form-item>
      </el-form>
      <!-- <div>由于支付宝风控原因，一个月只能提现一次</div> -->
      <div slot="footer">
        <el-button @click="showWithdrawDialog = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitWithdraw"
          :loading="withdrawLoading"
          :disabled="!me.alipay_account || me.last_withdraw_month==currentYearMonth"
          >确认提现</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import api from "../../api";

export default {
  name: "Settlements",
  data() {
    return {
      me: {
        withdrawable_balance: 0,
        withdrawn_balance: 0,
        last_withdraw_month:null,
      },
      records: [],
      loading: false,
      total: 0,
      page: 1,
      pageSize: 20,
      showWithdrawDialog: false,
      withdrawForm: {
        amount: null,
      },
      withdrawLoading: false,
      filters: {
        record_type: "",
        status: "",
      },
      currentYearMonth:null
    };
  },
  async created() {
    await this.fetchMe();
    const now = new Date();
    this.currentYearMonth = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}`;
    this.fetchRecords();
  },
  methods: {
    async fetchMe() {
      try {
        const { data } = await api.get("/api/users/me");
        this.me = data;
      } catch (e) {
        console.error(e);
      }
    },
    async fetchRecords(page = 1) {
      this.page = page;
      this.loading = true;
      try {
        const params = { page, page_size: this.pageSize };
        if (this.filters.record_type)
          params.record_type = this.filters.record_type;
        if (this.filters.status) params.status = this.filters.status;

        const { data } = await api.get("/api/users/balance-records", {
          params,
        });
        this.records = data.items || [];
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error("加载记录失败");
      } finally {
        this.loading = false;
      }
    },
    async submitWithdraw() {
      const amount = this.withdrawForm.amount;

      if (!amount || amount <= 0) {
        this.$message.warning("请输入有效的提现金额");
        return;
      }
      if (amount < 100) {
        this.$message.warning("单笔提现金额最低100元");
        return;
      }
      if (amount % 100 !== 0) {
        this.$message.warning("提现金额需为100元的整倍数");
        return;
      }
      if (amount > this.me.withdrawable_balance / 100) {
        this.$message.warning("提现金额不能超过可提现金额");
        return;
      }

      this.withdrawLoading = true;
      try {
        // 转换为分
        const amountFen = Math.floor(this.withdrawForm.amount * 100);
        const { data } = await api.post("/api/users/withdraw", {
          amount: amountFen,
        });
        if (data.code === 0) {
          this.$message.success("提现申请提交成功");
          this.showWithdrawDialog = false;
          this.withdrawForm.amount = null;
          await this.fetchMe();
          this.fetchRecords(1);
        } else {
          this.$message.error(data.message || "提现失败");
        }
      } catch (e) {
        this.$message.error("提现失败");
      } finally {
        this.withdrawLoading = false;
      }
    },
    fenToYuan(fen) {
      const n = Number(fen || 0);
      return (n / 100).toFixed(2);
    },
    getStatusType(status) {
      const map = {
        pending: "warning", // 待处理 - 黄色
        completed: "success", // 已完结 - 绿色
        failed: "danger", // 失败 - 红色
        payback: "success", //打款失败，回退
      };
      return map[status] || "info";
    },
    getStatusText(status) {
      const map = {
        pending: "审核中",
        completed: "已打款",
        failed: "提现失败",
        payback: "已退还",
      };
      return map[status] || status;
    },
  },
};
</script>

<style scoped>
.page-hedaer {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.page-title {
  margin: 0;
}
.title-info {
  color: #909399;
  margin-left: 5px;
  font-size: 12px;
}
.balance-row {
  margin-bottom: 20px;
}
.balance-card {
  text-align: center;
  padding: 10px;
}
.balance-label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 8px;
}
.balance-value {
  color: #303133;
  font-size: 24px;
  font-weight: bold;
}
.filter-form {
  margin: 20px 0;
}
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}
.income {
  color: #67c23a;
  font-weight: bold;
}
.expense {
  color: #f56c6c;
  font-weight: bold;
}
.withdraw-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
  line-height: 14px;
}
</style>
